"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCdsLib = parseCdsLib;
const COMMENT_MARKER = '--';
function parseCdsLib(content) {
    const defines = new Map();
    const includes = [];
    for (const rawLine of content.split(/\r?\n/)) {
        const line = stripComment(rawLine).trim();
        if (line.length === 0) {
            continue;
        }
        const tokens = line.split(/\s+/);
        const directive = tokens[0].toUpperCase();
        if (directive === 'DEFINE' && tokens.length >= 3) {
            const libName = tokens[1];
            const path = tokens.slice(2).join(' ');
            defines.set(libName, path);
            continue;
        }
        if ((directive === 'INCLUDE' || directive === 'SOFTINCLUDE') && tokens.length >= 2) {
            includes.push({
                type: directive,
                path: tokens.slice(1).join(' '),
            });
            continue;
        }
    }
    return { defines, includes };
}
function stripComment(line) {
    const idx = line.indexOf(COMMENT_MARKER);
    if (idx < 0) {
        return line;
    }
    const before = idx === 0 ? '' : line[idx - 1];
    if (idx === 0 || before === ' ' || before === '\t') {
        return line.slice(0, idx);
    }
    return line;
}
//# sourceMappingURL=cdsLibParser.js.map